(() => {
  if (window.__guttifulShippingProtectionInit) return;
  window.__guttifulShippingProtectionInit = true;

  function fetchConfig(contentType = 'application/json') {
    return {
      method: 'POST',
      headers: { 'Content-Type': contentType, Accept: 'application/json' },
    };
  }

  // Re-renders the same sections Dawn's own cart-drawer quantity updates
  // do (cart-drawer, cart-icon-bubble), so the toggle stays in sync with
  // totals/item count without duplicating Dawn's full CartItems update
  // machinery.
  function renderSections(sections) {
    const sectionIds = [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' },
    ];

    sectionIds.forEach(({ id, section, selector }) => {
      const html = sections[section];
      if (!html) return;
      const container = document.getElementById(id);
      if (!container) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newContent = doc.querySelector(selector);
      const target = container.matches(selector) ? container : container.querySelector(selector);
      if (newContent && target) {
        target.innerHTML = newContent.innerHTML;
      }
    });
  }

  function setLoading(toggleWrap, loading) {
    if (toggleWrap) toggleWrap.classList.toggle('is-loading', loading);
  }

  function setProtection(variantId, shouldAdd, { toggleWrap, checkbox } = {}) {
    setLoading(toggleWrap, true);
    if (checkbox) checkbox.disabled = true;

    const sections = ['cart-drawer', 'cart-icon-bubble'];

    const request = shouldAdd
      ? fetch(window.routes.cart_add_url + '.js', {
          ...fetchConfig(),
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        })
      : fetch(window.routes.cart_change_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            id: variantId,
            quantity: 0,
            sections,
            sections_url: window.location.pathname,
          }),
        });

    return request
      .then((response) => response.json().then((state) => ({ ok: response.ok, state })))
      .then(({ ok, state }) => {
        // A 422 (e.g. "sold out") still resolves as valid JSON here, not a
        // rejected fetch — checking response.ok explicitly is what actually
        // catches that case.
        if (!ok) throw new Error(state.message || 'Cart update failed');
        if (state.sections) renderSections(state.sections);
        return true;
      })
      .catch(() => {
        if (checkbox) checkbox.checked = !checkbox.checked;
        return false;
      })
      .finally(() => {
        setLoading(toggleWrap, false);
        if (checkbox) checkbox.disabled = false;
      });
  }

  document.addEventListener('change', (event) => {
    const checkbox = event.target.closest('#ShippingProtectionToggle');
    if (!checkbox) return;

    const variantId = checkbox.dataset.variantId;
    const toggleWrap = checkbox.closest('.shipping-protection');
    setProtection(variantId, checkbox.checked, { toggleWrap, checkbox });
  });

  // If the cart has real items, the toggle should default to "on" — no
  // memory of a previous decline; it resets to on again every time.
  //
  // The checkbox only exists in the DOM once the cart actually has items,
  // so it isn't there yet on a fresh page load with an empty cart. A plain
  // DOMContentLoaded check (what this used to be) only ever runs once at
  // that initial empty-cart moment and never again — so on the common
  // empty-cart-then-add-an-item flow, the checkbox appears later (via
  // Dawn's own cart re-render, or this script's own renderSections above)
  // and nothing was left listening for that. A MutationObserver catches
  // the checkbox appearing no matter what caused the DOM swap, and also
  // covers the initial-load-with-items case by running once immediately.
  let autoAddInFlight = false;

  function maybeAutoAddProtection() {
    if (autoAddInFlight) return;
    const checkbox = document.getElementById('ShippingProtectionToggle');
    if (!checkbox || checkbox.checked || checkbox.disabled) return;

    autoAddInFlight = true;
    const variantId = checkbox.dataset.variantId;
    const toggleWrap = checkbox.closest('.shipping-protection');
    checkbox.checked = true;
    setProtection(variantId, true, { toggleWrap, checkbox }).finally(() => {
      autoAddInFlight = false;
    });
  }

  maybeAutoAddProtection();
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    new MutationObserver(() => maybeAutoAddProtection()).observe(cartDrawer, { childList: true, subtree: true });
  }
})();
